import {Avatar, Button, Tag} from 'antd'
import classNames from 'classnames'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {BsCalendar2Week, BsCalendar3, BsEnvelope, BsPerson, BsPersonVcard, BsTelephone} from 'react-icons/bs'
import {FaUserGraduate} from 'react-icons/fa6'
import {MdOutlineEmail} from 'react-icons/md'
import {IdentifierTypes} from 'views/AppLocals/appFieldTypes'
import _ from 'lodash'
import {GoDotFill} from "react-icons/go";
import {formatSimplifyDate} from "../../../../helpers/dateUtils";
import {ifThenElseMultipleConditions} from "../../../../helpers/ifThenElseMultipleConditions";

const matchConfig = {
    identifier: {label: 'identifier match', color: 'red', priority: 1},
    email: {label: 'email match', color: 'orange', priority: 2},
    phone: {label: 'phone match', color: 'blue', priority: 3},
    name_dob: {label: 'name dob match', color: 'green', priority: 4},
    name_similar: {label: 'name similar match', color: 'default', priority: 5},
}

const CandidateField = ({icon = <GoDotFill size={10} className="text-color-500"/>, value}) => {
    if (!value) return null
    return (
        <div className="mb-0.5 flex items-center gap-1.5 text-xs">
            <span className="flex flex-center text-color-300">
                {icon}
            </span>
            <span className="text-color-100 tracking-wide italic">
                {value}
            </span>
        </div>
    )
}

export const CandidateCard = ({
                                  candidate,
                                  onSelectExisting,
                                  onViewDetail,
                                  loading = false,
                              }) => {
    const t = useTranslate()
    const {match_type, student} = candidate ?? {}
    const config = matchConfig[match_type] ?? matchConfig.name_similar

    const yearOfBirth = student?.date_of_birth
        ? new Date(student.date_of_birth).getFullYear()
        : null

    const identifierLabel = _.find(IdentifierTypes, {value: student?.identifier_type})?.label

    return (
        <div className="flex flex-col shadow-md rounded-xl transition-all duration-300">
            {/* Match badge + confidence */}
            <div
                className={classNames(
                    "p-3 flex items-center justify-between border-b rounded-t-xl",
                    ifThenElseMultipleConditions(
                        'border-color-100 background-50',
                        config.priority = 1, 'border-primary-500 bg-primary-50',
                        config.priority = 2, 'border-orange-200 bg-orange-50',
                        config.priority = 3, 'border-blue-400 bg-blue-50',
                        config.priority = 4, 'border-green-400 bg-green-50',
                    ),
                )}>
                <Tag color={config.color} className="m-0 font-medium">
                    {t(config.label)}
                </Tag>
                {/*{config.priority <= 2 && (*/}
                {/*    <span className="text-2xs text-orange-500 font-semibold uppercase tracking-wide">*/}
                {/*        {t('high match')}*/}
                {/*    </span>*/}
                {/*)}*/}
                {ifThenElseMultipleConditions(
                    '',
                    config.priority = 1, <span className="text-2xs text-primary-700 font-semibold uppercase tracking-wide">{t('highest match')}</span>,
                    config.priority = 2, <span className="text-2xs text-orange-500 font-semibold uppercase tracking-wide">{t('high match')}</span>,
                    config.priority = 3, <span className="text-2xs text-blue-500 font-semibold uppercase tracking-wide">{t('moderate match')}</span>,
                    config.priority  = 4, <span className="text-2xs text-green-500 font-semibold uppercase tracking-wide">{t('low match')}</span>,
                )}
            </div>

            {/* Student info */}
            <div className="p-3 flex items-start gap-3">
                <Avatar
                    size={36}
                    src={student?.avatar}
                    icon={<FaUserGraduate size={16} className="text-color-400"/>}
                    className="flex-shrink-0 flex flex-center background-200"
                />
                <div className="flex flex-col flex-1 min-w-0">
                    <span className="flex items-baseline gap-1 font-bold text-sm text-color-000 tracking-wider leading-snug">
                        {student?.patron_saint_name && (
                            <span className="font-medium">
                                {student?.patron_saint_name}
                            </span>
                        )}
                        {student?.fullname}
                    </span>
                    <div className="mb-1 flex items-center gap-x-4 gap-y-1">
                        {student?.student_idcode && (
                            <span className="font-mono text-xs text-blue-500 leading-snug">
                                #{student.student_idcode}
                            </span>
                        )}
                        {student?.identifier_code && (
                            <div className="flex items-center gap-1 text-xs leading-snug">
                                <BsPersonVcard size={11} className="text-color-500"/>
                                <span className="text-color-400 tracking-wider">
                                    {`${t(identifierLabel ?? 'ID')}:`}
                                </span>
                                <span className="font-mono text-blue-500">
                                    {student.identifier_code}
                                </span>
                            </div>
                        )}
                    </div>
                    <CandidateField value={formatSimplifyDate(student?.date_of_birth, '', 'DD/MM/YYYY')}/>
                    <CandidateField value={student?.contact_phone}/>
                    <CandidateField value={student?.contact_email}/>
                </div>
            </div>

            {/* Actions */}
            <div className="p-3 flex justify-end gap-2 border-t border-color-50">
                <Button
                    color="default" variant="filled"
                    onClick={() => onViewDetail(student)}
                    className="text-xs rounded-lg">
                    {t('view detail')}
                </Button>
                <Button
                    color="primary" variant="solid"
                    loading={loading}
                    onClick={() => onSelectExisting(student)}
                    className="text-xs rounded-lg">
                    {t('use existing student')}
                </Button>
            </div>
        </div>
    )
}
